import {Route, Routes, Router} from 'react-router-dom'
import "./App.css";

import ScrollToTop from './components/ScrollToTop';

import Home from "./pages/home"
import SingleEvent from './pages/singleevent';
import Category from './pages/category';

import Signup from './pages/auth/signup';
import SigninPage from './pages/auth/signin';
import ContactUs from './pages/contact';
import HelpCenter from './pages/HowItWorks';

import ProtectedRoute from './pages/account/protected';
import Dashboard from './pages/account/pages';
import EventManagement from './pages/account/pages/EventManagement';
import WalletAndCoin from './pages/account/pages/WalletAndCoin';
import AttendeeManagement from './pages/account/pages/AttendeeManagement';
import OrganizerSettings from './pages/account/pages/OrganizerSettings';
import ReportAnalytics from './pages/account/pages/ReportAnalytics';
import CreateEvent from './pages/account/pages/ticket/ticket';



import LoginPage from './admin/auth/login';
import AdminProtectedRoute from './admin/Layout/protected';
import AdminDashboard from './admin/pages/dashboard';
import AdminEventManagement from './admin/pages/EventManagement';
import AdminWalletAndCoin from './admin/pages/Wallet&Transaction';
import AdminAttendeeManagement from './admin/pages/UserManagement';


import CheckoutPage from './pages/CheckoutPage';
import BookingConfirmationPage from './pages/BookingConfirmationPage';



export default function AllRouter() {


    return (
    <div>
        <ScrollToTop />
        <Routes>
       
        <Route path="/" element={<Home />} />
        <Route path="/single-event/:id" element={<SingleEvent />} />

        <Route path="/single-event/checkout/:eventId" element={<CheckoutPage />} />
        <Route path="/single-event/booking-confirmed/:bookingId" element={<BookingConfirmationPage />} />

        <Route path="/category/:categoryName" element={<Category />} />

        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<SigninPage />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/helpcenter" element={<HelpCenter />} />

        <Route path="/dashboard" element={ <ProtectedRoute/>   }>
          <Route index element={<Dashboard />} />
          <Route path="event-management" element={<EventManagement />} />
          <Route path="wallet&coin" element={<WalletAndCoin />} />
          <Route path="attendee-management" element={<AttendeeManagement />} />
          <Route path="organizer-settings" element={<OrganizerSettings />} />
          <Route path="report-analytics" element={<ReportAnalytics />} />
          <Route path="event-management/create-event" element={<CreateEvent />} />
      </Route>


      <Route path="/admin/login" element={<LoginPage />} />

      <Route path="/admin/dashboard" element={ <AdminProtectedRoute/>   }>
          <Route index element={<AdminDashboard />} />
          <Route path="event-management" element={<AdminEventManagement />} />
          <Route path="wallet&coin" element={<AdminWalletAndCoin />} />
          <Route path="attendee-management" element={<AttendeeManagement />} />

          
  
      </Route>

      </Routes>
    </div>
    );
}